import { type ReactNode } from "react";
import { formatINR, formatPct } from "@/lib/format";

interface Props {
  label: string;
  value: number;
  change?: number;
  changePct?: number;
  prefix?: string;
  icon?: string;
  color?: "green" | "red" | "amber" | "blue";
}

const COLOR_MAP = {
  green: "var(--green)",
  red: "var(--red)",
  amber: "var(--amber)",
  blue: "var(--primary)",
};

export default function NavCard({
  label,
  value,
  change,
  changePct,
  prefix,
  icon,
  color,
}: Props) {
  const isPositive = change != null && change >= 0;
  const changeColor = isPositive ? "var(--green-light)" : "var(--red-light)";

  return (
    <div className="card" style={{ position: "relative", overflow: "hidden" }}>
      {color && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: 4,
            height: "100%",
            background: COLOR_MAP[color],
          }}
        />
      )}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div>
          <div style={{ fontSize: 12, color: "var(--text-muted)", marginBottom: 4, textTransform: "uppercase", letterSpacing: 0.05 }}>
            {label}
          </div>
          <div style={{ fontSize: 24, fontWeight: 700, fontFamily: "var(--font-mono)" }}>
            {prefix || "₹"}{formatINR(value).replace("₹", "").trim()}
          </div>
          {change != null && (
            <div style={{ fontSize: 13, marginTop: 4, fontFamily: "var(--font-mono)", color: changeColor }}>
              {isPositive ? "▲" : "▼"} {formatINR(Math.abs(change)).replace("₹", "").trim()}
              {changePct != null && ` (${formatPct(Math.abs(changePct))})`}
            </div>
          )}
        </div>
        {icon && (
          <div style={{ fontSize: 28, opacity: 0.3 }}>{icon}</div>
        )}
      </div>
    </div>
  );
}
